import React, { useEffect, useState } from 'react';
import { ShieldCheck, Sparkles } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../utils/AdminAuthContext';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const { login, isAdminLoggedIn } = useAdminAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdminLoggedIn) {
      navigate('/admin', { replace: true });
    }
  }, [isAdminLoggedIn, navigate]);

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(form.email, form.password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Nie udało się zalogować do panelu admina.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page admin-login-page">
      <div className="login-card auth-card--wide auth-card--compact admin-login-card">
        <div className="login-logo"><Sparkles size={22} strokeWidth={1.8} /></div>
        <p className="login-kicker">ClientWay Admin</p>
        <h1 className="login-title auth-title-small">Panel operacyjny</h1>
        <p className="login-subtitle">Osobne logowanie dla operatora systemu i wsparcia.</p>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="adminEmail">Email</label>
            <input id="adminEmail" type="email" value={form.email} onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))} autoComplete="email" required />
          </div>
          <div className="form-group">
            <label htmlFor="adminPassword">Hasło</label>
            <input id="adminPassword" type="password" value={form.password} onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))} autoComplete="current-password" required />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            <ShieldCheck size={16} strokeWidth={1.9} />
            {loading ? 'Logowanie...' : 'Zaloguj do admina'}
          </button>
        </form>
      </div>
    </div>
  );
}